import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { RouterModule , Routes } from '@angular/router'
import { environment } from '../environments/environment';


//theme


// Navigation
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
// Buttons & Indicators
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

// Data table
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

//layout
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';

//swiper
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';


//special function
import { from } from 'rxjs';
import { GoogleMapsModule } from '@angular/google-maps'
import { YouTubePlayerModule } from '@angular/youtube-player';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

//main
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './component/footer/footer.component';
import { ToolbarComponent } from './component/toolbar/toolbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './component/home/home.component';
import { SwiperComponent } from './component/swiper/swiper.component';
import { MenuComponent } from './component/menu/menu.component';
import { BulletinComponent } from './component/bulletin/bulletin.component';
import { StripHtmlTagsPipe } from './pipe/strip-html-tags.pipe';
import { LiveAirComponent } from './component/live-air/live-air.component';
import { VideosComponent } from './component/videos/videos.component';
import { LunchComponent } from './component/lunch/lunch.component';
import { ClassWebsiteComponent } from './component/class-website/class-website.component';
import { ScheduleComponent } from './component/schedule/schedule.component';
import { PhoneExtensionComponent } from './component/phone-extension/phone-extension.component';
import { SexualHarassmentComponent } from './component/sexual-harassment/sexual-harassment.component';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

const routes: Routes = [
  
  { path: '', component:HomeComponent },
  { path: 'schedule', component: ScheduleComponent },
  { path: 'phone-extension', component: PhoneExtensionComponent },
  { path: 'sexual-harassment', component: SexualHarassmentComponent  },
  { path: 'class-websites', component: ClassWebsiteComponent }
   
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    ToolbarComponent,
    HomeComponent,
    SwiperComponent,
    MenuComponent,
    BulletinComponent,
    StripHtmlTagsPipe,
    LiveAirComponent,
    VideosComponent,
    LunchComponent,
    ClassWebsiteComponent,
    ScheduleComponent,
    PhoneExtensionComponent,
    SexualHarassmentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule, HttpClientModule,
    MatMenuModule, MatSidenavModule, MatToolbarModule,
    MatButtonModule, MatButtonToggleModule, MatRippleModule, MatIconModule, 
    FlexLayoutModule, MatListModule, MatCardModule, 
    MatSortModule, MatTableModule, MatPaginatorModule,
    SwiperModule, 
    GoogleMapsModule, YouTubePlayerModule, NgxExtendedPdfViewerModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    RouterModule.forRoot(routes)
  ],
  exports:[
    VideosComponent
  ],

  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
